<template>
  <div class="open-app" v-show="show">
    <div class="close" @click="show = !show">
      <img src="@/assets/student/closeX.png" alt="" />
    </div>
    <div class="logo">
      <img src="@/assets/usercenter/parentHandbook/logo.png" alt="" />
    </div>
    <div class="desc">打开美术宝1对1 APP</div>
    <div class="open" @click="openApp('h5', path)">
      <span>立即打开</span>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { openApp } from "@/utils/openApp";

export default Vue.extend({
  data() {
    return {
      show: true
    };
  },

  computed: {
    path() {
      let url = this.$route.query.openapp;

      if (url === "cpage") {
        url = location.href;
      }
      return url;
    }
  },

  methods: {
    openApp(type: string, url: string) {
      openApp({ type, url });
    }
  },

  mounted() {
    this.openApp("h5", this.path as string);
  }
});
</script>

<style lang="scss" scoped>
.open-app {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 750px;
  height: 128px;
  background: rgb(0 0 0 / 70%);
  img {
    width: 100%;
    height: 100%;
  }
  .close {
    margin-left: 28px;
    width: 36px;
    height: 36px;
  }
  .logo {
    width: 88px;
    height: 88px;
  }
  .desc {
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
  }
  .open {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 244px;
    height: 100%;
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    background-color: #ff3300;
    line-height: 40px;
  }
}
</style>
